module.exports = __webpack_public_path__ + "img/图1-12  使用Matplotlib绘制的图形.f8bc9333.png";